import React from 'react';
import {
   Typography,
   Container,
   Paper,
   Box,
   Button,
   Alert,
} from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const CancelConfirmation = () => {
   const navigate = useNavigate();

   return (
      <Container maxWidth="md" sx={{ mt: 5 }}>
         <Paper sx={{ p: 4, textAlign: 'center' }}>
            <Box sx={{ mb: 3 }}>
               <CheckCircleIcon 
                  sx={{ 
                     fontSize: 60, 
                     color: 'success.main',
                     mb: 2 
                  }} 
               />
               <Typography variant="h4" component="h1" gutterBottom>
                  Subscription Canceled
               </Typography>
               <Typography variant="h6" color="text.secondary" sx={{ mb: 3 }}>
                  Your subscription has been successfully canceled
               </Typography>
            </Box>

            <Alert severity="info" sx={{ mb: 3, textAlign: 'left' }}>
               <Typography variant="body1" sx={{ mb: 2 }}>
                  <strong>What happens next:</strong>
               </Typography>
               <Typography variant="body2" component="div">
                  • Your subscription will remain active until the end of your current billing period
                  <br />
                  • You'll continue to have access to all features until then
                  <br />
                  • You can reactivate your subscription anytime before it expires
                  <br />
                  • No further charges will be made to your payment method
               </Typography>
            </Alert>

            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
               <Button
                  variant="contained"
                  color="primary"
                  onClick={() => navigate('/dashboard')}
                  sx={{ minWidth: 150 }}
               >
                  Go to Dashboard
               </Button>
               <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => navigate('/personal-subscription')}
                  sx={{ minWidth: 150 }}
               >
                  View Subscription
               </Button>
            </Box>

            <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
               Need help? Contact our support team for assistance.
            </Typography>
         </Paper>
      </Container>
   );
};

export default CancelConfirmation;
